<template>
  <div>

    <body class="home">
      <div class="video-container ">
        <video class="video-player" autoplay muted @ended="onVideoEnded" controls
          poster="@/assets/images/about/videoimg.png">
          <source src="https://dev-1251342732.cos.ap-guangzhou.myqcloud.com/mg.mp4" type="video/mp4">
          您的浏览器不支持 video 标签，请更换浏览器尝试。
        </video>
      </div>
      <div class="gd"></div>
      <!-- 英雄区域 -->
      <div class="hero">
        <div class="hero-up">
          <div class="up-left">
            <h1 class="title">
              趣味<span class="text-orange">学</span>单词 <span class="text-orange">熊猫</span>伴你行
            </h1>
            <p class="subtitle">AI单词+AI练口语=专属梦幻家园</p>
            <div class="buttons">
              <div class="button iosbutton" @click="godownload">
                <div class="button-text">IOS下载</div>
                <img src="@/assets/images/home/download.png" alt="">
              </div>
              <div class="button androidbutton" @click="godownload">
                <div class="button-text">Andriod下载</div>
                <img src="@/assets/images/home/download.png" alt="">
              </div>
            </div>
          </div>
          <div class="up-right">
            <el-carousel height="100%" style="width:100%;height: 100%;" autoplay loop indicator-position="none">
              <el-carousel-item v-for="item in bannerImages" :key="item.id">
                <img style="width: 100%;" :src="item.src" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="hero-down">
          <div class="down-tex">荣誉获奖</div>
          <div class="down">
            <div class="heros">
              <img src="@/assets/images/home/hero1.png" alt="">
              <img class="hero-img" src="@/assets/images/home/hero2.png" alt="">
              <img src="@/assets/images/home/hero3.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 功能特色区域 -->
      <div class="featurestitle">
        为什么选择熊猫在学?
      </div>

      <div class="features">
        <ul>
          <li><img src="@/assets/images/home/web_rect01.png" alt=""></li>
          <li class="feature-img"><img src="@/assets/images/home/web_rect02.png" alt=""></li>
          <li><img src="@/assets/images/home/web_rect03.png" alt=""></li>
        </ul>
        <ul>
          <li><img src="@/assets/images/home/web_rect04.png" alt=""></li>
          <li class="feature-img"><img src="@/assets/images/home/web_rect05.png" alt=""></li>
          <li><img src="@/assets/images/home/web_rect06.png" alt=""></li>
        </ul>
      </div>
      <div class="features2">
        <ul>
          <li><img src="@/assets/images/home/web_rect01.png" alt=""></li>
          <li><img src="@/assets/images/home/web_rect02.png" alt=""></li>
        </ul>
        <ul>
          <li><img src="@/assets/images/home/web_rect03.png" alt=""></li>
          <li><img src="@/assets/images/home/web_rect04.png" alt=""></li>
        </ul>
        <ul>
          <li><img src="@/assets/images/home/web_rect05.png" alt=""></li>
          <li><img src="@/assets/images/home/web_rect06.png" alt=""></li>
        </ul>
      </div>

      <!-- 学习进度展示区域 -->
      <div class="intro">
        <div class="intro-item">
          <div class="intro-left">
            <img src="https://dev-1251342732.cos.ap-guangzhou.myqcloud.com/01-min.png" alt="">
          </div>
          <div class="intro-right">
            <div class="intro-title">海量词书 教材同步学</div>
            <div class="intro-text">从小学到雅思托福，四六级到商务英语，超10万+高频词汇、专业词库实时更新，满足你的每一阶段学习目标。</div>
          </div>
        </div>
        <div class="intro-item">
          <div class="intro-right intro-w">
            <div class="intro-title">高效记忆 多种学习模式</div>
            <div class="intro-text">五种不同题型，听说读写面面俱到；学习阶段测试根据词书，学习内容测试，综合诊断掌握情况。</div>
          </div>
          <div class="intro-left">
            <img src="https://dev-1251342732.cos.ap-guangzhou.myqcloud.com/02-min.png" alt="">
          </div>
        </div>
        <div class="intro-item">
          <div class="intro-left">
            <img src="https://dev-1251342732.cos.ap-guangzhou.myqcloud.com/03-min.png" alt="">
          </div>
          <div class="intro-right">
            <div class="intro-title">一对一AI外教练口语</div>
            <div class="intro-text">24小时贴身陪练，开口就是地道英语，AI智能捕捉语法错误、发音偏差，即时标注纠正，并给出地道表达建议，每句话都有进步！</div>
          </div>
        </div>
        <div class="intro-item">
          <div class="intro-right intro-w">
            <div class="intro-title">趣味闯词 学会、玩会！</div>
            <div class="intro-text">玩法超多，越学越嗨。化身单词勇士，一路闯关打怪！每记一个词都是经验值，每过一关都是新成就，学习像打游戏一样热血沸腾！</div>
          </div>
          <div class="intro-left">
            <img class="last" src="https://dev-1251342732.cos.ap-guangzhou.myqcloud.com/04-min.png" alt="">
          </div>
        </div>
      </div>
    </body>
    <!-- CTA区域 -->
    <div class="gosvip">
      <div class="home svip1">
        <div class="gosvip-left">
          <img src="@/assets/images/home/pandaimg.png" alt="">
        </div>
        <div class="gosvip-right">
          <div class="grup">
            <img class="grup-img1" src="@/assets/images/home/svipicon.png" alt="">
            <img class="grup-img2" src="@/assets/images/home/sviptext.png" alt="">
          </div>
          <div class="grdown" @click="gosvip">
            <!-- <img src="@/assets/images/home/button_svip_normal.png" alt=""> -->
          </div>

        </div>
      </div>
    </div>
    <div class="start home">
      <div class="start-up">
        <div class="start-left">
          <div>追踪你的学习进度</div>
          <div class="xcx-button" @click="openerwm">
            <div>小程序</div>
            <img src="@/assets/images/home/xcxicon.png" alt="">
            <div class="qrcode-popup" v-show="isshowerwm">
              <div class="popup-title">扫码体验官方小程序</div>
              <img src="@/assets/images/home/xcx.png" alt="视频号二维码">
            </div>
          </div>
        </div>
        <div class="start-right">
          <img src="@/assets/images/home/report.png" alt="">
        </div>

      </div>
      <div class="start-down">
        <div>来熊猫在学</div>
        <div class="start-down-text">开启你的学习之旅!</div>
        <div class="start-button" @click="godownload">
          开始学习
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import info from '@/utils/getInfo'

export default {
  name: 'HomeView',
  data() {
    return {
      // 轮播图片
      bannerImages: [
        { id: 1, src: require('@/assets/images/home/banner1.png') },
        { id: 2, src: require('@/assets/images/home/banner2.png') },
        { id: 3, src: require('@/assets/images/home/banner1.png') },
        { id: 4, src: require('@/assets/images/home/banner2.png') }
      ],
      isshowerwm: false
    }
  },
  methods: {
    // 打开小程序二维码
    openerwm() {
      this.isshowerwm = !this.isshowerwm
    },
    // 去下载
    godownload() {
      this.$router.push('/download')
    },
    // 去vip
    gosvip() {
      this.$router.push('/membership')
      info.trackEvent(info.EVENT_ID.PAGE_VIEW, {
        "page": "首页"
      })
    },
    // 视频播放完成后的处理函数
    onVideoEnded() {
      // 滚动到英雄区域
      const heroElement = document.querySelector('.gd');
      if (heroElement) {
        heroElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
  mounted() {
    info.trackEvent(info.EVENT_ID.PAGE_VIEW, {
      "page": "首页"
    })

    // 移除视频的循环播放属性并尝试播放
    const video = this.$refs.videoPlayer;

  },


}

</script>

<style scoped>
.title {
  font-family: GenSenRounded TW-H;
  color: #333333;
  font-size: 55px;
}

.text-orange {
  color: #FFA10F;
}

.gd {
  height: 30px;
  width: 100%;
  margin-bottom: 50px;
}

.hero-up {
  display: flex;
  justify-content: space-between;
}

.up-left {
  margin-top: 277px;
}

.subtitle {
  margin-top: 17px;
  font-family: Source Han Sans SC-Regular;
  font-weight: Regular;
  color: #666666;
  font-size: 24px;
}

.buttons {
  margin-top: 83px;
  display: flex;
}

.button {
  width: 219px;
  height: 64px;
  background-color: rgba(165, 232, 65, 1);
  border-radius: 20px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #FFFFFF;
  font-size: 20px;
  font-family: Source Han Sans SC-Regular;
  font-weight: Regular;
  cursor: pointer;
}

.button:hover {
  background-color: rgba(162, 243, 41, 1);
  transform: scale(0.99);
}

.button img {
  width: 38px;
  height: 38px;
}

.iosbutton {
  margin-right: 20px;
}

.up-right {
  margin-right: -100px;
  width: 722px;
  height: 722px;
}

.hero-down {
  height: 82px;
  display: flex;
  align-items: center;
  position: relative;
  font-family: Source Han Sans SC-Medium;
  color: #333333;
  font-size: 20px;
  margin-top: 30px;
}

.down {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.heros {
  display: flex;
}

.heros img {
  width: 173.72px;
  height: 45.89px;
}

.featurestitle {
  font-family: GenSenRounded TW-B;
  color: #333333;
  font-size: 48px;
  text-align: center;
  margin-top: 136px;
}

.features {
  margin-top: 104px;
}

.intro {
  margin-top: 170px;
  margin-bottom: 100px;
}

.gosvip {
  height: 1080px;
  width: 100%;
  background-color: #F8F8F8;
}

.svip1 {
  width: 100%;
  height: 1080px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.gosvip-left img {
  margin-top: -175px;
  width: 533px;
  height: 524px;
}

.grup {
  display: flex;
  align-items: center;
}

.gosvip-right {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.grdown {
  width: 375px;
  height: 237px;
  background: url('@/assets/images/home/button_svip_normal.png') no-repeat;
  background-size: 100% 100%;
  /* 图片完全拉伸至容器大小 */
  margin-top: 50px;
  cursor: pointer;
}

.grdown:hover {
  background: url('@/assets/images/home/button_svip_hover.png') no-repeat;
  background-size: 100% 100%;
  /* 图片完全拉伸至容器大小 */
  transform: scale(0.99);
}

.grdown img {
  width: 375px;
  height: 237px;
}

.start {
  width: 100%;
}

.start-up {
  margin-top: 162px;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.start-left {
  font-family: GenSenRounded TW-B;
  color: #333333;
  font-size: 48px;
}

.start-right img {
  width: 685.86px;
  height: 610.34px;
}

.xcx-button {
  position: relative;
  width: 205px;
  height: 64px;
  border-radius: 20px;
  background-color: rgba(255, 229, 95, 1);
  font-size: 20px;
  font-family: Source Han Sans SC-Medium;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  margin-top: 60px;
  cursor: pointer;
}

.xcx-button:hover {
  background-color: rgba(255, 241, 39, 1);
  transform: scale(0.99);
}

.xcx-button img {
  width: 34px;
  height: 34px;
}

.start-down {
  margin-top: 300px;
  font-family: GenSenRounded TW-H;
  color: #FFA10F;
  font-size: 66.29px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.start-button {
  width: 219px;
  height: 64px;
  background-color: rgba(255, 229, 95, 1);
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-family: Source Han Sans SC-Medium;
  color: #333333;
  margin: 120px auto;
  cursor: pointer;
}

.start-button:hover {
  background-color: rgba(255, 241, 39, 1);
  transform: scale(0.99);
}

.start-button img {
  width: 38px;
  height: 38px;
}

.start-down img {
  width: 100px;
  height: 100px;
  margin-top: 40px;
}

.qrcode-popup {
  position: absolute;
  width: 258px;
  height: 314px;
  bottom: 34px;
  left: 0px;
  background: url('@/assets/images/footer/qrbg.png') no-repeat center;
  background-size: 100% 100%;
  z-index: 99;
  text-align: center;
  font-size: 16px;
  color: #333333;
}

.qrcode-popup img {
  margin: 16px auto;
  width: 159px;
  height: 159px;
}

.popup-title {
  margin-top: 48px;
}

.grup-img1 {
  width: 106px;
  height: 106px;
  margin-right: 25px;
}

.grup-img2 {
  width: 508px;
  height: 63px;
}

.hero-img {
  margin: 0 59px;
}

.features ul {
  display: flex;
  justify-content: center;
  margin-bottom: -26px;
}

.features img {
  width: 487px;
  height: 363px;
}

.features img:hover {
  transform: scale(1.1);
}

.intro-item {
  margin-bottom: 188px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.intro-left img {
  /* width: 539px; */
  height: 798px;
}

/* .intro-left img:hover {
  transform: scale(1.1);
} */

.intro-right {
  width: 443px;
}

.intro-title {
  font-family: GenSenRounded TW-B;
  color: rgba(51, 51, 51, 1);
  font-size: 48px;
}

.intro-text {
  margin-top: 38px;
  font-family: Source Han Sans SC-Medium;
  color: rgba(102, 102, 102, 1);
  font-size: 19px;
  line-height: 38px;
}

.intro-w {
  width: 491px;
}

.last {
  width: 632px;
  height: 712px;
}

.feature-img {
  margin: 0 -30px;
}

.start-down-text {
  margin-top: 60px;
}

.video-container {
  margin-top: 120px;
  width: 100%;
  /* 可根据实际需求调整宽度 */
  height: 747.1px;
  border-radius: 58px;
  overflow: hidden;
  position: relative;
  /* 关键：隐藏超出容器的部分 */
}

.video-player {
  width: 101%;
  height: 101%;
  /* height: 747.1px; */
  border-radius: 58px;
  border: none;
  /* 移除播放器默认边框 */
  outline: none;
  /* 移除聚焦时的轮廓 */
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.features2 {
  display: none;
}

/* 移动端样式 (小于768px) */
@media screen and (max-width: 767px) {
  .hero {
    margin-top: 30px;
  }

  .hero-up {
    /* margin-top: 60px; */
  }

  .title {
    font-size: 33px;
  }

  .subtitle {
    font-size: 23px;
  }

  .up-right {
    width: 530px;
    height: 240px;
  }

  .buttons {
    display: static;
  }

  .button {
    width: 80px;
    height: 34px;
    font-size: 10px;
    justify-content: center;
  }

  .button img {
    margin-left: 1px;
    width: 16px;
    height: 16px;
  }

  .hero-down {
    height: 34px;
    font-size: 14px;
  }

  .down {
    position: static;
    /* 或 relative 根据需求 */
    left: auto;
    top: auto;
    transform: none;
    margin-left: 5px;
  }

  .up-left {
    margin-top: 20px;
  }

  .heros img {
    width: 80px;
    height: 23px;
  }

  .featurestitle {
    font-size: 20px;
    margin-top: 45px;
  }

  .video-player {
    height: 100%;
  }

  .features2 {
    display: block;
    margin-top: 20px;
  }

  .features2 img {
    width: 100%;
  }

  .features {
    display: none;
  }



  .intro-right {
    width: 124px;
  }

  .intro-title {
    font-size: 20px;
  }

  .intro-text {
    font-size: 14px;
    line-height: 18px;
  }

  .intro-text {
    width: 124px;
  }

  .intro-left img {
    height: 300px;
  }

  .intro-left .last {
    width: 195px;
    height: 265px;
  }

  .gosvip {
    /* height: 422px; */
  }

  .intro-item {
    margin-bottom: 80px;
    display: flex;
    justify-content: center;
  }

  .gosvip-left img {
    width: 138px;
    height: 135px;
  }

  .grup-img1 {
    width: 41px;
    height: 41px;
  }

  .grup-img2 {
    width: 152px;
    height: 21px;
  }

  .grdown {
    width: 123px;
    height: 90px;
  }

  .gosvip-right {
    margin-top: 20px;
  }

  .start-right img {
    width: 232px;
    height: 207px;
  }

  .start-left {
    font-size: 14px;
  }

  .xcx-button {
    width: 80px;
    height: 25px;
    font-size: 10px;
    margin-top: 23px;
  }

  .xcx-button img {
    width: 13px;
    height: 13px;
  }

  .start-down {
    font-size: 26px;
  }

  .start-button {
    width: 86px;
    height: 25px;
    font-size: 10px;
  }

  .video-container {
    margin-top: 80px;
  }

  .qrcode-popup {
    width: 200px;
    height: 230px;
    font-size: 13px;
    left: -30px;
  }

  .qrcode-popup img {
    margin: 10px auto;
    width: 123px;
    height: 123px;
  }

  .popup-title {
    margin-top: 28px;
  }
}
</style>
